import * as Yup from 'yup'

const mergeCustomersValidator = Yup.object ({
  prev_customer: Yup
    .object ()
    .nullable ()
    .required ('Selecione o cliente cujos dados deseja transferir'),

  new_customer: Yup
    .object ()
    .nullable ()
    .required ('Selecione o cliente para o qual deseja transferir os dados')
})

export default mergeCustomersValidator
